import React from "react";

export const escapedNewLineToLineBreakTag = string =>
  string
    .split("\n")
    // eslint-disable-next-line react/no-array-index-key
    .map((item, index) => (index === 0 ? item : [<br key={index} />, item]));

export const isString = value => typeof value === "string";

export const localizeString = (string, translations) => {
  const translationKey = string
    .split(" ")
    .map(text => text.toLowerCase())
    .join("_");

  return translations[translationKey] || string;
};
